// variantes-imagenes.js - Versión estable (sin observers)
(function() {
  if (!document.querySelector('main[data-template="product"]')) return;

  const CODIGOS = {
    'brown mole': 'bm', 'black carbon': 'bc', 'green forest': 'gf',
    'red flower': 'fx', 'black vulture': 'bv', 'blue royal': 'br',
    'light grey': 'lg', 'dark grey': 'dg'
  };

  // ============================================
  // VISOR DE IMÁGENES
  // ============================================
  let visor = null;
  let visorImg = null;
  let imagenesVisor = [];
  let indiceActual = 0;

  function crearVisor() {
    if (visor) return;
    const esMovil = window.innerWidth <= 768;
    visor = document.createElement('div');
    visor.id = 'visor-imagenes';
    visor.style.cssText = `
      display:none;position:fixed;top:0;left:0;width:100%;height:100%;
      background:rgba(0,0,0,.95);z-index:9999999;justify-content:center;
      align-items:center;flex-direction:column;
    `;
    visor.innerHTML = `
      <div style="position:relative;width:100%;height:100%;display:flex;justify-content:center;align-items:center;">
        <img id="visorImg" style="max-width:90%;max-height:80%;object-fit:contain;transition:opacity .2s;cursor:pointer;">
        <button id="visorCerrar" style="position:absolute;top:${esMovil ? '10' : '20'}px;right:${esMovil ? '10' : '20'}px;background:#fff;border:none;border-radius:50%;width:${esMovil ? '36' : '44'}px;height:${esMovil ? '36' : '44'}px;font-size:${esMovil ? '18' : '24'}px;cursor:pointer;z-index:10000000;display:flex;justify-content:center;align-items:center;box-shadow:0 2px 8px rgba(0,0,0,.3);border:2px solid #333;transition:all .2s;">✕</button>
        <button id="visorPrev" style="position:absolute;left:${esMovil ? '5' : '10'}px;top:50%;transform:translateY(-50%);background:transparent;border:none;color:#fff;width:${esMovil ? '44' : '50'}px;height:${esMovil ? '44' : '50'}px;font-size:${esMovil ? '40' : '48'}px;cursor:pointer;z-index:10000000;display:flex;justify-content:center;align-items:center;line-height:0;padding-bottom:8px;text-shadow:0 2px 5px rgba(0,0,0,.5);opacity:${esMovil ? '.8' : '.5'};transition:opacity .2s;">‹</button>
        <button id="visorNext" style="position:absolute;right:${esMovil ? '5' : '10'}px;top:50%;transform:translateY(-50%);background:transparent;border:none;color:#fff;width:${esMovil ? '44' : '50'}px;height:${esMovil ? '44' : '50'}px;font-size:${esMovil ? '40' : '48'}px;cursor:pointer;z-index:10000000;display:flex;justify-content:center;align-items:center;line-height:0;padding-bottom:8px;text-shadow:0 2px 5px rgba(0,0,0,.5);opacity:${esMovil ? '.8' : '.5'};transition:opacity .2s;">›</button>
        <div id="visorContador" style="position:absolute;bottom:30px;left:50%;transform:translateX(-50%);background:rgba(0,0,0,.7);color:#fff;padding:8px 16px;border-radius:30px;font-size:14px;font-family:Arial,sans-serif;border:1px solid rgba(255,255,255,.3);z-index:10000000;"></div>
      </div>
    `;
    document.body.appendChild(visor);

    visorImg = document.getElementById('visorImg');
    const cerrar = document.getElementById('visorCerrar');
    const prev = document.getElementById('visorPrev');
    const next = document.getElementById('visorNext');

    if (!esMovil) {
      [prev, next].forEach(btn => {
        btn.addEventListener('mouseenter', () => btn.style.opacity = '1');
        btn.addEventListener('mouseleave', () => btn.style.opacity = '.5');
      });
    } else {
      visor.addEventListener('touchstart', () => {
        prev.style.opacity = next.style.opacity = '.8';
        clearTimeout(window.flechasTimeout);
        window.flechasTimeout = setTimeout(() => {
          prev.style.opacity = next.style.opacity = '.3';
        }, 2000);
      });
    }

    cerrar.onclick = (e) => { e.stopPropagation(); visor.style.display = 'none'; };
    visor.onclick = (e) => { if (e.target === visor) visor.style.display = 'none'; };
    prev.onclick = (e) => { e.stopPropagation(); navegarImagen(-1); };
    next.onclick = (e) => { e.stopPropagation(); navegarImagen(1); };

    document.addEventListener('keydown', (e) => {
      if (visor.style.display !== 'flex') return;
      if (e.key === 'Escape') visor.style.display = 'none';
      else if (e.key === 'ArrowLeft') navegarImagen(-1);
      else if (e.key === 'ArrowRight') navegarImagen(1);
    });

    let touchStartX = 0;
    visor.addEventListener('touchstart', (e) => { touchStartX = e.changedTouches[0].screenX; }, { passive: true });
    visor.addEventListener('touchend', (e) => {
      const diff = e.changedTouches[0].screenX - touchStartX;
      if (diff < -50) navegarImagen(1);
      else if (diff > 50) navegarImagen(-1);
    }, { passive: true });
  }

  function navegarImagen(dir) {
    if (!imagenesVisor.length) return;
    indiceActual = (indiceActual + dir + imagenesVisor.length) % imagenesVisor.length;
    visorImg.style.opacity = '0';
    setTimeout(() => {
      visorImg.src = imagenesVisor[indiceActual];
      visorImg.style.opacity = '1';
      actualizarContador();
    }, 150);
  }

  function actualizarContador() {
    const c = document.getElementById('visorContador');
    if (c) c.textContent = `${indiceActual + 1} / ${imagenesVisor.length}`;
  }

  function abrirVisor(src, imagenes) {
    crearVisor();
    imagenesVisor = imagenes;
    indiceActual = imagenesVisor.indexOf(src);
    if (indiceActual === -1) indiceActual = 0;
    visorImg.src = src;
    visor.style.display = 'flex';
    actualizarContador();
  }

  // ============================================
  // FILTRADO Y ORDEN DE IMÁGENES POR VARIANTE
  // ============================================
  let filtroTimeout = null;

  function forzarCargaImagenes() {
    document.querySelectorAll('.product__media-item img[loading="lazy"]').forEach(img => {
      img.setAttribute('loading', 'eager');
    });
  }

  function reordenarImagenes() {
    const listaMedios = document.querySelector('.product__media-list');
    if (!listaMedios) return;
    const itemsVisibles = Array.from(
      document.querySelectorAll('.product__media-item:not([style*="none"])')
    );
    if (itemsVisibles.length <= 1) return;
    const itemsConOrden = itemsVisibles.map(item => {
      const img = item.querySelector('img');
      const alt = img ? img.getAttribute('alt') || '' : '';
      const numeroMatch = alt.match(/(\d{2})$/);
      const numero = numeroMatch ? parseInt(numeroMatch[1], 10) : 999;
      return { elemento: item, numero };
    });
    itemsConOrden.sort((a, b) => a.numero - b.numero);
    itemsConOrden.forEach(item => listaMedios.appendChild(item.elemento));
    forzarCargaImagenes();
    window.dispatchEvent(new Event('resize'));
  }

  function filtrarPorVariante() {
    const seleccionada = document.querySelector('.product-form__input input[type="radio"]:checked + label');
    if (!seleccionada) return;
    const nombre = seleccionada.innerText.trim().toLowerCase();
    const codigo = CODIGOS[nombre] || '';
    if (!codigo) return;
    const regex = new RegExp('\\b' + codigo + '\\b', 'i');
    const items = document.querySelectorAll('.product__media-item, [data-media-id]');
    const imagenesAMostrar = [];
    items.forEach(item => {
      const img = item.querySelector('img');
      if (!img) return;
      const alt = img.getAttribute('alt') || '';
      if (regex.test(alt)) imagenesAMostrar.push(item);
    });
    items.forEach(item => item.style.display = 'none');
    imagenesAMostrar.forEach(item => item.style.display = '');
    setTimeout(reordenarImagenes, 50);
    setTimeout(forzarCargaImagenes, 100);
    if (window.innerWidth < 768 && imagenesAMostrar.length) {
      setTimeout(() => {
        const primerSlide = document.querySelector('.product__media-item:not([style*="none"])');
        if (primerSlide) primerSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }, 150);
    }
  }

  // ============================================
  // ASIGNACIÓN DE EVENTOS A RADIOBUTTONS (con debounce)
  // ============================================
  function asignarEventosVariantes() {
    const radios = document.querySelectorAll('.product-form__input input[type="radio"]');
    radios.forEach(radio => {
      radio.removeEventListener('change', manejarCambioVariante);
      radio.addEventListener('change', manejarCambioVariante);
    });
  }

  function manejarCambioVariante() {
    if (filtroTimeout) clearTimeout(filtroTimeout);
    filtroTimeout = setTimeout(() => {
      filtrarPorVariante();
      filtroTimeout = null;
    }, 150);
  }

  // ============================================
  // DELEGACIÓN DE EVENTOS PARA CLICS EN IMÁGENES
  // ============================================
  document.addEventListener('click', (e) => {
    const img = e.target.closest('.product__media-item img, [data-media-id] img');
    if (!img) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    const visibles = Array.from(
      document.querySelectorAll('.product__media-item:not([style*="none"]) img')
    ).map(i => i.src);
    if (visibles.length) abrirVisor(img.src, visibles);
    return false;
  }, true);

  // ============================================
  // INICIALIZACIÓN
  // ============================================
  setTimeout(() => {
    asignarEventosVariantes();
    filtrarPorVariante();
    forzarCargaImagenes();
    console.log('✅ Visor de imágenes estable activado');
  }, 500);
})();